import * as React from 'react';
import { useDispatch } from 'react-redux';
import { MapModal } from '../Components/MapModal/MapModal';
import { useMapDisplayContext } from '../MapDisplayContext';
import styles from './StarredModal.module.css';
import { AnimatedButton } from 'components/Map/AnimatedButton';
import { useTranslation } from 'react-i18next';
import { setHasViewedStarredPinModal } from 'ducks/client/starredPins';

interface Props {
  onClose: () => void;
}

export const StarredModal = ({ onClose }: Props) => {
  const { t } = useTranslation();
  const { setShowStarredPinList, setPinInfoDisplayState } = useMapDisplayContext();

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setHasViewedStarredPinModal(true));
  }, [dispatch]);

  return (
    <MapModal onClose={onClose}>
      <h2 className={styles.subtitle}>{t('Starred Pins')}</h2>
      <div className={styles.description}>{t('We keep all your favorites in one place')}</div>
      <div className={styles.buttonContainer}>
        <AnimatedButton
          className={styles.yesButton}
          onClick={() => {
            setShowStarredPinList(true);
            setPinInfoDisplayState({ pinKey: null, displayState: 'HIDDEN' });
            onClose();
          }}
          clickedClassName={styles.clicked}
        >
          {t('View Starred Pins')}
        </AnimatedButton>
        <AnimatedButton
          className={styles.noButton}
          onClick={onClose}
          clickedClassName={styles.clicked}
        >
          {t('Back')}
        </AnimatedButton>
      </div>
    </MapModal>
  );
};
